// extracted by mini-css-extract-plugin
module.exports = {"views":"styles_views__QWiWM","viewsIcon":"styles_viewsIcon__TpuFL"};